<!-- AGセグメント登録 -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">エージェントセグメント登録</h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <!-- AGセグメント一覧 -->
      <div class="">
        <!-- 一覧ファイルアップロード用項目 -->
        <input
          type="file"
          ref="fileInput"
          @change="handleFileUpload"
          style="display: none"
          accept=".csv"
        />
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">削除</th>
              <th
                :class="[
                  'col_agSegmentId',
                  'sortable',
                  isDirectionASC('agSegmentId') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('agSegmentId')"
              >
                セグメントID
              </th>
              <th
                :class="[
                  'col_agSegmentName',
                  'sortable',
                  isDirectionASC('agSegmentName') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('agSegmentName')"
              >
                セグメント名
              </th>
              <th class="col_syozokuAgCnt">所属AG数</th>
              <th class="col_lastUploadDate">最終取込日</th>
              <th class="col_uploadFileName">アップロードファイル名</th>
              <th class="col_uploadDataCnt">取込件数</th>
              <th class="col_btnDownload">DL</th>
              <th class="col_btnUpload">UPL</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in paginatedData"
              :key="item.agSegmentId"
              :class="{ changed: item.isChangeAgSegmentName }"
            >
              <td class="col_selection" data-name="mSelection">
                <input
                  id="mSelection"
                  v-model="item.selection"
                  type="checkbox"
                  class="form-check-input"
                />
              </td>
              <td class="col_agSegmentId" data-name="mAgSegmentId">
                {{ item.agSegmentId }}
              </td>
              <td
                class="col_agSegmentName"
                data-name="mAgSegmentName"
                v-bind:class="
                  item.isChangeAgSegmentName ? 'changed' : 'unchanged'
                "
              >
                <input
                  style="
                    border: powderblue solid 1px;
                    text-align: left;
                    padding-left: 8px;
                  "
                  class="txt_agSegmentName form-control"
                  id="mAgSegmentId"
                  v-model="item.agSegmentName"
                  type="text"
                  maxlength="255"
                  @blur="onBlurAgSegmentName(item)"
                  v-bind:class="
                    item.isChangeAgSegmentName ? 'changed' : 'unchanged'
                  "
                />
              </td>
              <td
                class="col_syozokuAgCnt"
                data-name="mSyozokuAgCnt"
                style="text-align: right; padding-right: 8px"
              >
                {{ item.syozokuAgCnt }}
              </td>
              <td class="col_lastUploadDate" data-name="mLastUploadDate">
                {{ item.lastUploadDate }}
              </td>
              <td
                class="col_uploadFileName"
                data-name="mUploadFileName"
                style="text-align: left; padding-left: 8px"
              >
                {{ item.uploadFileName }}
              </td>
              <td
                class="col_uploadDataCnt"
                data-name="mUploadDataCnt"
                style="text-align: right; padding-right: 8px"
              >
                {{ item.uploadDataCnt }}
              </td>
              <td class="col_btnDownload" data-name="mBtnDownload">
                <button
                  type="button"
                  name="mBtnDownload"
                  class="btn btn-sm"
                  @click="onDownload(item.agSegmentId)"
                >
                  <img :src="imageDownLoad" alt="↓" />
                </button>
              </td>
              <td class="col_btnUpload" data-name="mBtnUpload">
                <button
                  type="button"
                  name="mBtnUpload"
                  class="btn btn-sm"
                  @click="onUpload(item.agSegmentId)"
                >
                  <img :src="imageUpload" alt="↑" />
                </button>
                <MessageModal
                  :isOpen="isOpenMessageModal"
                  :message="modalMessage"
                  @response="handleMessageResponse"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <content-pagination
          :current-page="currentPage"
          :total-pages="totalPages"
          :items-per-page="itemsPerPage"
          @page-changed="handlePageChange"
        />
        <br />
        <div class="form-inline flex-container">
          <div class="form-group">
            <button
              type="button"
              name="btnDelete"
              class="btn btn-footer btn-primary"
              @click="onDelete"
            >
              削除
            </button>
          </div>

          <div class="form-group">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="onBack"
            >
              戻る
            </button>
            <button
              type="button"
              name="btnClear"
              class="btn btn-footer btn-primary"
              @click="onClear"
            >
              クリア
            </button>
            <button
              type="button"
              name="btnUpdate"
              class="btn btn-footer btn-primary"
              @click="onUpdate"
            >
              更新
            </button>
            <button
              type="button"
              name="btnAdd"
              class="btn btn-footer btn-primary"
              @click="onNewRegister"
            >
              新規登録
            </button>
            <AgSegmentModal
              :isOpen="isOpenAgSegmentModal"
              :agCode="agCode"
              :userId="userId"
              :categoryId="categoryId"
              @closed="handleAgSegmentModalClosed"
              @registered="handleAgSegmentModalRegistered"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>
<script lang="ts">
import { defineComponent, computed, onMounted, ref } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import ContentPagination from "../controls/ContentPagination.vue";
import { useRouter } from "vue-router";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import apiAuthClient from "@/util/apiClientAuth";
import { AppConstants } from "@/constants/AppConstants";
import {
  formatMessage,
  sanitizeInput,
  hasNoGaiji,
  checkFileName,
  isTokenAlive,
  commonHandleAxiosError,
} from "@/Common";
import AgSegmentModal from "../layout/AgSegmentModalComponent.vue";
import MessageModal from "../layout/MessageModalComponent.vue";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import ImageDownload from "@/assets/common/img/icon-download.png";
import ImageUpload from "@/assets/common/img/icon-upload.png";
import { useUserStore } from "@/store/userStore";

interface AgSegmentListItem {
  selection: boolean;
  agSegmentId: string;
  agSegmentName: string;
  syozokuAgCnt: number;
  lastUploadDate: string;
  uploadFileName: string;
  uploadDataCnt: number;
  beforeAgSegmentName: string;
  isChangeAgSegmentName: boolean;
}

interface AgSegmentData {
  agSegmentId: string;
  agSegmentName: string;
}

interface AgSegmentSortItem {
  key: string;
  direction: string;
}

class AgSegmentRegConstants {
  // API-URL
  static readonly API_URL_LIST_DISPLAY = "/api/AgSegment/getAgSegmentList";
  static readonly API_URL_DOWNLOAD = "/api/AgSegment/download/agSegment";
  static readonly API_URL_UPLOAD = "/api/AgSegment/upload/agSegment";
  static readonly API_URL_CREATE = "/api/AgSegment/create/agSegment";
  static readonly API_URL_UPDATE = "/api/AgSegment/update/agSegment";
  static readonly API_URL_DELETE = "/api/AgSegment/delete/agSegment";

  // ソート種別
  static readonly SORT_TYPE_ASC = "ASC"; // 昇順
  static readonly SORT_TYPE_DESC = "DESC"; // 降順
}

export default defineComponent({
  name: "AgSegmentRegComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    ContentPagination,
    AgSegmentModal,
    MessageModal,
    BackToTop,
  },
  setup() {
    const router = useRouter();
    const { getCategoryIdByName } = useUserParmitionStore();
    const processingStore = useProcessingStore();
    const errorMessage = ref("");
    const agCode = ref("");
    const userId = ref("");
    const categoryId = ref("");
    const agSegmentList = ref<AgSegmentListItem[]>([]);
    const agSegmentSortItemList = ref<AgSegmentSortItem[]>([]);
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(15); // 1ページに表示する最大件数
    const uploadAgSegmentId = ref("");
    const fileInput = ref<HTMLInputElement | null>(null);
    const selectedFile = ref<File | null>(null);
    const isOpenAgSegmentModal = ref(false);
    const isOpenMessageModal = ref(false);
    const modalMessage = ref("");
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const imageDownLoad = ref(ImageDownload);
    const imageUpload = ref(ImageUpload);
    const { logoutUser } = useUserStore();

    // 初期処理
    onMounted(async () => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
      }

      // カテゴリID取得
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_AG_SEGMENT_TOUROKU
      ) as string;

      // 処理中フラグON
      processingStore.isProcessing = true;

      // 初期処理時はTrue
      isInitError.value = true;

      try {
        // AGセグメント一覧情報取得
        if (await getAgSegmentList()) {
          // 先頭ページ表示
          currentPage.value = 1;
        } else {
          return;
        }
        // 初期処理が正常に終了したら解除
        isInitError.value = false;
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * AGセグメント一覧：AGセグメント名のフォーカス喪失時の処理
     * @param error Agセグメントデータ
     */
    const onBlurAgSegmentName = (item: AgSegmentListItem) => {
      // 値が変更されたどうかをチェック
      item.isChangeAgSegmentName =
        item.agSegmentName !== item.beforeAgSegmentName;
    };

    /**
     * DLボタン押下
     */
    const onDownload = async (agSegmentId: string) => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      // AGセグメント情報出力
      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // API呼出し
        const response = await apiAuthClient.post(
          AgSegmentRegConstants.API_URL_DOWNLOAD,
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: categoryId.value,
            agSegmentData: {
              agSegmentId: agSegmentId,
            },
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        // サーバ側から返されたファイル名を取得
        const disposition = response.headers["content-disposition"];
        let fileName = "download.csv";
        if (disposition && disposition.includes("filename*=UTF-8")) {
          const matches = /filename\*=UTF-8''(.+)/.exec(disposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }

        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * アップロード処理
     * ：UPLボタン押下イベントであり、File属性のイベント発火
     */
    const onUpload = (agSegmentId: string) => {
      // メッセージクリア
      errorMessage.value = "";

      // 対象AGセグメントIDを設定
      uploadAgSegmentId.value = agSegmentId;

      // ファイル選択イベント発火
      if (fileInput.value) {
        fileInput.value.value = "";
        fileInput.value.click();
      }
    };

    /**
     * アップロード処理
     * ：File属性のイベントであり、選択ファイルのチェック処理を実施
     */
    const handleFileUpload = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // 初期化
      selectedFile.value = null;
      isOpenMessageModal.value = false;
      modalMessage.value = "";

      try {
        const file = fileInput.value?.files?.[0];
        if (file) {
          // 拡張子のチェック
          if (!file.name.toLowerCase().endsWith(".csv")) {
            errorMessage.value = formatMessage(messages.ERR_0010);
            return;
          }

          // ファイル名のチェック
          if (!checkFileName(file.name.toLowerCase())) {
            errorMessage.value = formatMessage(messages.ERR_0025, "ファイル名");
            return;
          }

          // レコード数のチェック
          const recordCount = await getCsvRecordCount(file);
          if (recordCount === 0) {
            errorMessage.value = formatMessage(messages.ERR_0011);
            return;
          }

          // 選択ファイルの情報を設定
          selectedFile.value = file;
          isOpenMessageModal.value = true;
          modalMessage.value =
            file.name +
            "を取り込みます。\n取込件数：" +
            recordCount +
            "件\n\nよろしいですか？";
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * アップロード処理
     * ：CSVファイルを読み込み、レコード数を取得
     */
    const getCsvRecordCount = (file: File): Promise<number> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const csvText = event.target?.result as string;
          const records = csvText
            .split(/\r\n|\n/)
            .filter((line) => line.trim() !== "");
          resolve(records.length);
        };
        reader.onerror = () => {
          reject(reader.error);
        };
        reader.readAsText(file);
      });
    };

    /**
     * アップロード処理
     * ：確認ダイアログ画面から復帰イベント
     */
    const handleMessageResponse = async (response: boolean) => {
      isOpenMessageModal.value = false;

      // 確認ダイアログの操作判定
      if (!response) {
        // いいえ押下
        selectedFile.value = null;
      }

      if (!selectedFile.value) return;

      // 処理中フラグON
      processingStore.isProcessing = true;

      // AGセグメントファイル取込
      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // API呼出し
        const formData = new FormData();
        formData.append("systemKbn", AppConstants.SYSTEM_KBN_WITH);
        formData.append("agCode", agCode.value);
        formData.append("userId", userId.value);
        formData.append("categoryId", categoryId.value ?? "");
        formData.append("agSegmentData.agSegmentId", uploadAgSegmentId.value);
        formData.append("agSegmentData.uploadFile", selectedFile.value);

        await apiAuthClient.post(
          AgSegmentRegConstants.API_URL_UPLOAD,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        // 完了メッセージ表示
        alert(
          formatMessage(
            messages.INF_0001,
            selectedFile.value.name,
            "アップロード"
          )
        );
        selectedFile.value = null;

        // AGセグメント一覧情報取得
        if (await getAgSegmentList()) {
          // 先頭ページ表示
          currentPage.value = 1;
        }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 削除ボタン押下
     */
    const onDelete = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // 削除対象絞り込み
        const targetList: AgSegmentData[] = agSegmentList.value
          .filter((agSegment) => agSegment.selection)
          .map((agSegment) => ({
            agSegmentId: agSegment.agSegmentId,
            agSegmentName: "",
          }));

        // 選択件数チェック
        if (targetList.length < 1) {
          errorMessage.value = formatMessage(messages.ERR_0003, "明細");
          return;
        }

        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "エージェントセグメント", "削除")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // AGセグメント削除
        try {
          // トークン有効性チェック
          if ((await isTokenAlive()) == false) {
            // トークンが無効な場合はログイン画面へ
            logoutUser();
            alert(messages.ERR_USER001);
            router.push("/login");
            return;
          }

          // API呼出し
          await apiAuthClient.post(AgSegmentRegConstants.API_URL_DELETE, {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: categoryId.value,
            agSegmentDataList: targetList,
          });

          // 完了メッセージ表示
          alert(
            formatMessage(messages.INF_0001, "エージェントセグメント", "削除")
          );

          // AGセグメント一覧情報取得
          if (await getAgSegmentList()) {
            // 先頭ページ表示
            currentPage.value = 1;
          }
        } catch (error: unknown) {
          // エラー処理
          handleAxiosError(error);
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // AGセグメント名変更対象絞り込み
      const targetList = agSegmentList.value.filter(
        (agSegment) => agSegment.isChangeAgSegmentName
      );

      // AGセグメント名変更対象チェック
      if (targetList.length > 0) {
        // 確認ダイアログ表示
        const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
        if (!isConfirm) {
          // いいえの場合
          return;
        }
      }

      // 管理者トップへ遷移
      router.push("/kanrisya-top");
    };

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // AGセグメント名変更対象絞り込み
        const targetList = agSegmentList.value.filter(
          (agSegment) => agSegment.isChangeAgSegmentName
        );

        // AGセグメント名変更対象チェック
        if (targetList.length > 0) {
          // 確認ダイアログ表示
          const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
          if (!isConfirm) {
            // いいえの場合
            return;
          }
        }

        // AGセグメント一覧情報取得
        if (await getAgSegmentList()) {
          // 先頭ページ表示
          currentPage.value = 1;
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 更新ボタン押下
     */
    const onUpdate = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // AGセグメント名変更対象絞り込み
        const targetList: AgSegmentData[] = agSegmentList.value
          .filter((agSegment) => agSegment.isChangeAgSegmentName)
          .map((agSegment) => ({
            agSegmentId: agSegment.agSegmentId,
            agSegmentName: sanitizeInput(agSegment.agSegmentName),
          }));

        // 選択件数チェック
        if (targetList.length < 1) {
          errorMessage.value = formatMessage(messages.ERR_0008, "明細");
          return;
        }

        // 入力チェック
        if (!validateInput(targetList)) {
          return;
        }

        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "エージェントセグメント", "更新")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // AGセグメント更新
        try {
          // API呼出し
          await apiAuthClient.post(AgSegmentRegConstants.API_URL_UPDATE, {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: categoryId.value,
            agSegmentDataList: targetList,
          });

          // 完了メッセージ表示
          alert(
            formatMessage(messages.INF_0001, "エージェントセグメント", "更新")
          );

          // AGセグメント一覧情報取得
          if (await getAgSegmentList()) {
            // 先頭ページ表示
            currentPage.value = 1;
          }
        } catch (error: unknown) {
          // エラー処理
          handleAxiosError(error);
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 更新チェック処理
     */
    const validateInput = (targetList: AgSegmentData[]): boolean => {
      // 入力チェック
      if (
        targetList.filter((agSegment) => agSegment.agSegmentName != "").length <
        1
      ) {
        errorMessage.value = formatMessage(
          messages.ERR_0001,
          "エージェントセグメント名"
        );
        return false;
      }

      if (
        targetList.filter((agSegment) => !hasNoGaiji(agSegment.agSegmentName))
          .length > 0
      ) {
        errorMessage.value = formatMessage(
          messages.ERR_0026,
          "エージェントセグメント名"
        );
        return false;
      }

      return true;
    };

    /**
     * 新規登録ボタン押下
     * ：モーダル画面を表示
     */
    const onNewRegister = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";

      // モーダル画面表示
      isOpenAgSegmentModal.value = true;
    };

    /**
     * 新規登録 >> ダイアログ画面で戻る処理を実行
     */
    const handleAgSegmentModalClosed = async () => {
      isOpenAgSegmentModal.value = false;
    };

    /**
     * 新規登録 >> ダイアログ画面で登録処理を実行
     */
    const handleAgSegmentModalRegistered = async () => {
      isOpenAgSegmentModal.value = false;

      // 処理中フラグON
      processingStore.isProcessing = true;

      // AGセグメント一覧情報取得
      try {
        if (await getAgSegmentList()) {
          // 先頭ページ表示
          currentPage.value = 1;
        }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 検索結果のソート処理を行います。
     * @param key ソート項目
     */
    const onSortItem = (key: string) => {
      agSegmentSortItemList.value.forEach((sortItem) => {
        if (sortItem.key == key) {
          switch (sortItem.key) {
            case "agSegmentId":
              if (sortItem.direction == AgSegmentRegConstants.SORT_TYPE_ASC) {
                // 降順
                agSegmentList.value.sort((a, b) =>
                  b.agSegmentId.localeCompare(a.agSegmentId)
                );
              } else {
                // 昇順
                agSegmentList.value.sort((a, b) =>
                  a.agSegmentId.localeCompare(b.agSegmentId)
                );
              }
              break;
            case "agSegmentName":
              if (sortItem.direction == AgSegmentRegConstants.SORT_TYPE_ASC) {
                // 降順
                agSegmentList.value.sort((a, b) =>
                  b.agSegmentName.localeCompare(a.agSegmentName)
                );
              } else {
                // 昇順
                agSegmentList.value.sort((a, b) =>
                  a.agSegmentName.localeCompare(b.agSegmentName)
                );
              }
              break;
          }

          if (sortItem.direction == AgSegmentRegConstants.SORT_TYPE_ASC) {
            sortItem.direction = AgSegmentRegConstants.SORT_TYPE_DESC;
          } else {
            sortItem.direction = AgSegmentRegConstants.SORT_TYPE_ASC;
          }
        }
      });
    };

    /**
     * ソート項目の初期値を返却します。
     */
    const getSortItemListDef = () => {
      return [
        {
          key: "agSegmentId",
          direction: AgSegmentRegConstants.SORT_TYPE_ASC,
        },
        {
          key: "agSegmentName",
          direction: AgSegmentRegConstants.SORT_TYPE_ASC,
        },
      ];
    };

    /**
     * ソート順が昇順か判定します。
     * @param key ソート項目
     */
    const isDirectionASC = (key: string): boolean => {
      let result = false;
      agSegmentSortItemList.value.forEach((sortItem) => {
        if (sortItem.key == key) {
          if (sortItem.direction == AgSegmentRegConstants.SORT_TYPE_ASC) {
            result = true;
          }
        }
      });
      return result;
    };

    /**
     * ページネーションのデータ生成
     */
    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return agSegmentList.value.slice(start, end);
    });

    /**
     * 頁総数を取得
     */
    const totalPages = computed(() => {
      return Math.ceil(agSegmentList.value.length / itemsPerPage.value);
    });

    /**
     * ページ切替ハンドラ
     */
    const handlePageChange = (page: number) => {
      currentPage.value = page;
    };

    /**
     * AGセグメント一覧情報取得
     */
    const getAgSegmentList = async (): Promise<boolean> => {
      // AGセグメント一覧情報取得
      try {
        // API呼出し
        const response = await apiAuthClient.post(
          AgSegmentRegConstants.API_URL_LIST_DISPLAY,
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: categoryId.value,
          }
        );

        // レスポンスを保持
        agSegmentList.value = response.data.agSegmentDataList;
        // ソート状態を保持
        agSegmentSortItemList.value = getSortItemListDef();

        return true;
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        return false;
      }
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    return {
      errorMessage,
      isInitError,
      router,
      agCode,
      userId,
      categoryId,
      onDownload,
      onUpload,
      onDelete,
      onBack,
      onClear,
      onUpdate,
      onNewRegister,
      currentPage,
      itemsPerPage,
      paginatedData,
      totalPages,
      handlePageChange,
      onSortItem,
      getSortItemListDef,
      isDirectionASC,
      onBlurAgSegmentName,
      handleFileUpload,
      fileInput,
      isOpenMessageModal,
      modalMessage,
      handleMessageResponse,
      isOpenAgSegmentModal,
      handleAgSegmentModalClosed,
      handleAgSegmentModalRegistered,
      imageDownLoad,
      imageUpload,
    };
  },
});
</script>

<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}
.col_selection {
  width: 4%;
}
.col_agSegmentId {
  width: 12%;
}
.col_agSegmentName {
  width: 25%;
}
.col_syozokuAgCnt {
  width: 8%;
}
.col_lastUploadDate {
  width: 10%;
}
.col_uploadFileName {
  width: 25%;
}
.col_uploadDataCnt {
  width: 8%;
}
.col_btnDownload {
  width: 4%;
}
.col_btnUpload {
  width: 4%;
}
.changed {
  background-color: #bed0f3;
}
.unchanged {
  background-color: #fffdbf;
}
.sortable {
  cursor: pointer;
  position: relative;
  padding-right: 20px;
}
.sortable::after {
  content: "";
  position: absolute;
  right: 5px;
}
.sortable.asc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: 0.1em 0 0 0.6em;
  transform: rotate(-135deg);
  vertical-align: middle;
  width: 8px;
}
.sortable.desc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: -0.5em 0 0 0.6em;
  transform: rotate(45deg);
  vertical-align: middle;
  width: 8px;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  text-align: center;
  vertical-align: middle;
}
</style>
